import { useState, useEffect } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Container,
  Button,
  Tab,
  Nav,
  Accordion,
  useAccordionToggle,
  Link,
  connect,
  CustomContainer,
  Cookie,
} from "../../atoms/DependencyHelper";
import LabelText from "../../atoms/label/LabelText";
import styles from "./PastUsage.module.scss";
import config from "../../../config/index";
import Image from "../../atoms/image/image";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import { getPastUsage } from "../../../Redux/actions/upgradeAction";
import ajaxServices from "../../../utils/ajaxServices";
import {
  getCookieValue,
  hideSpinner,
  showSpinner,
} from "../../../utils/helperServices";
import * as Analytics from "../../../services/analyticsUtag";
import microService from "../../../utils/microServices";
import { useRef } from "react";
import { componentResize } from "../../../utils/helperServices";

const PastUsage = (props) => {
  let jwtToken = props.responseToken["x-auth-jwt"];
  /*
  useEffect(() => {
    props.getPastUsage(props.selectedNumber);
  }, [props.selectedNumber])
*/
  // const [pastUsage, setPastUsage] = useState(props.pastUsage);
  const [pastConsumption, setPastConsumption] = useState();
  const [isApiError, setIsApiError] = useState(false);
  let overSpendDescription = props.pastUsageParagraph.description;
  const isMobile = componentResize();

  useEffect(() => {
    // setPastUsage(props.pastUsageData);
    overSpendDescription = overSpendDescription.replace(
      `[average_monthly_amount]&nbsp`,
      `${pastConsumption?.consumption?.spendMinusSubsc}`
    );
  }, [pastConsumption]);

  const [activeAccordion, setActiveAccordion] = useState("");
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const imgUrl = `${imagePrefix}/assets/images/warning-black.svg`;
  const errorImg = `${imagePrefix}/assets/images/error-circle-red.svg`;
  const backImg = `${imagePrefix}/assets/images/triangle-arrow.svg`;

  const btnConfig = {
    buttonStyle: "outline black",
    buttonLabel: "Back to top",
  };
  const goToTop = () => {
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: "shopping: upgrade: recommended deals: back to top",
    });
    window.scrollTo(0, 0);
  };

  const convertToGB = (val) => {
    if (val > 0) {
      return val / 1024;
    } else {
      return val;
    }
  };

  useEffect(() => {
    getConsumptionData();
  }, [props.selectedNumber]);

  const getConsumptionData = async () => {
    showSpinner();
    let loginStatus = Cookie.get("vod-web-auth-token") ? true : false;
    let eligibilityToken = Cookie.get("eligibility-token");
    const queryParams = `?msisdn=${props.selectedNumber}`;
    setPastConsumption();
    setIsApiError(false);
    const responseData = await microService.get(
      "api",
      "consumption",
      null,
      loginStatus,
      null,
      queryParams,
      false,
      loginStatus ? null : eligibilityToken
    );

    setPastConsumption(responseData?.response?.data?.result);
    setIsApiError(!responseData?.response?.data?.result);
    hideSpinner();
  };

  useEffect(() => {
    if (!pastConsumption) {
      Analytics.link({
        page_name: "shopping: upgrade: recommended deals",
        page_form_event: "error",
        page_errors:
          "We seem to be having some issues retrieving your past usage  data right now. Please try again later.",
        page_error_type: "page",
      });
    }
  }, [pastConsumption]);

  const tabNames = [
    {
      key: "MAU",
      title: "My average usage",
      description:
        "This is your average monthly data, voice and SMS usage over the past 6 months:",
      data: [
        {
          name: "Data",
          usage: `${convertToGB(
            pastConsumption?.consumption?.usage?.data
          )?.toFixed(2)}GB`,
          des: `${
            pastConsumption?.consumption?.usage?.data -
              pastConsumption?.currentDeal?.packages[0]?.includedData <
            0
              ? `Your current plan  gives you <strong class ="ml-xxs"> ${
                  pastConsumption?.currentDeal?.packages[0]?.includedData ==
                  "-1"
                    ? "Unlimited"
                    : convertToGB(
                        pastConsumption?.currentDeal?.packages[0]?.includedData
                      )?.toFixed(1)
                } GB data</strong>`
              : `Your current plan only gives you <strong class ="ml-xxs">${convertToGB(
                  pastConsumption?.currentDeal?.packages[0]?.includedData
                )?.toFixed(1)} GB data</strong> `
          }`,
          error:
            Number(pastConsumption?.consumption?.usage?.data) -
              Number(pastConsumption?.currentDeal?.packages[0]?.includedData) >
              0 &&
            pastConsumption?.currentDeal?.packages[0]?.includedData != "-1"
              ? true
              : false,
        },
        {
          name: "Voice",
          usage: `${pastConsumption?.consumption?.usage?.voice} min`,
          des: `${
            pastConsumption?.consumption?.usage?.voice -
              pastConsumption?.currentDeal?.packages[0]?.includedMinutes <
            0
              ? `Your current plan  gives you <strong class ="ml-xxs"> ${
                  pastConsumption?.currentDeal?.packages[0]?.includedMinutes ==
                  "-1"
                    ? "Unlimited"
                    : pastConsumption?.currentDeal?.packages[0]?.includedMinutes
                } minutes</strong>`
              : `Your current plan only gives you <strong class ="ml-xxs"> ${
                  pastConsumption?.currentDeal?.packages[0]?.includedMinutes ==
                  "-1"
                    ? "Unlimited"
                    : pastConsumption?.currentDeal?.packages[0]?.includedMinutes
                } minutes</strong>`
          }`,
          error:
            Number(pastConsumption?.consumption?.usage?.voice) -
              Number(
                pastConsumption?.currentDeal?.packages[0]?.includedMinutes
              ) >
              0 &&
            pastConsumption?.currentDeal?.packages[0]?.includedMinutes != "-1"
              ? true
              : false,
        },
        {
          name: "SMS",
          usage: `${pastConsumption?.consumption?.usage?.sms} SMS`,
          des: `${
            pastConsumption?.consumption?.usage?.sms -
              pastConsumption?.currentDeal?.packages[0]?.includedSms <
            0
              ? `Your current plan  gives you <strong class ="ml-xxs">${
                  pastConsumption?.currentDeal?.packages[0]?.includedSms == "-1"
                    ? "Unlimited"
                    : pastConsumption?.currentDeal?.packages[0]?.includedSms
                } SMSs</strong>`
              : `Your current plan only gives you <strong class ="ml-xxs">${
                  pastConsumption?.currentDeal?.packages[0]?.includedSms == "-1"
                    ? "Unlimited"
                    : pastConsumption?.currentDeal?.packages[0]?.includedSms
                } SMSs</strong>`
          }`,
          error:
            Number(pastConsumption?.consumption?.usage?.sms) -
              Number(pastConsumption?.currentDeal?.packages[0]?.includedSms) >
              0 &&
            pastConsumption?.currentDeal?.packages[0]?.includedSms != "-1"
              ? true
              : false,
        },
      ],
    },
    {
      key: "MAS",
      title: "My average spend",
      description: "This is your average monthly spend over the past 6 months:",
      data: [
        {
          name: "Average monthly spend",
          usage: `${
            pastConsumption?.consumption?.averageSpend?.toFixed(2) || "-"
          }PM`,
          des: `Your monthly contract cost is <strong class="ml-xxs">R ${pastConsumption?.consumption?.bill} PM</strong>`,
          error: pastConsumption?.consumption?.spendMinusSubsc > 0,
        },
        {
          name: "Average overspend per month",
          usage: `R${
            pastConsumption?.consumption?.spendMinusSubsc?.toFixed(2) || "-"
          }`,
          hidden: pastConsumption?.consumption?.spendMinusSubsc < 0,
        },
      ],
      overSpend: {
        title: "Why did I overspend?",
        overDesCription:
          "On average, your total bill amount was R60.99 more than your monthly contract cost. This is most likely due to going out-of-bundle on your data, voice and/or SMS allocations, or activating other services on your account. For more information, view your statement or contact Customer Care at 082 135.",
        overDesCription1:
          "To avoid overspending, you can select a deal with a Top Up plan, which won’t let you use more data or minutes unless you top up.",
      },
    },

    {
      key: "MCC",
      title: "My current contract",
      description: "",
      contract_data: [
        {
          type: "Contract details",
          data: [
            {
              label: "Contract duration",
              value: "-",
            },
            {
              label: "Contract start date",
              value: `${pastConsumption?.accountSummary?.startDate || "-"}`,
            },
            {
              label: "Contract end date",
              value: `${pastConsumption?.accountSummary?.endDate || "-"}`,
            },
            {
              label: "Contract type",
              value: `${
                pastConsumption?.currentDeal?.packages[0]?.packageTypeName ||
                "-"
              }`,
            },
            {
              label: "Total monthly contract cost:",
              value: `R ${pastConsumption?.consumption?.bill || "-"}`,
            },
          ],
        },
        {
          type: "Device details",
          data: [
            {
              label: "Device name",
              value: `${pastConsumption?.currentDevice?.deviceModel || "-"}`,
            },
            {
              label: "Monthly device cost",
              value: `R ${pastConsumption?.consumption?.handsetFinance || "-"}`,
            },
          ],
        },
        {
          type: "Plan details",
          data: [
            {
              label: "Plan name",
              value: `${pastConsumption?.Customer?.currentTariff || "-"}`,
            },
            {
              label: "Plan type",
              value: `${
                pastConsumption?.currentDeal?.packages[0]?.planType || "-"
              }`,
            },
            {
              label: "Monthly plan cost",
              value: `R ${pastConsumption?.consumption?.subscription || "-"}`,
            },
            {
              label: "Any time data",
              value: pastConsumption?.currentDeal?.packages[0]?.includedData ? `${
                pastConsumption?.currentDeal?.packages[0]?.includedData == "-1"
                  ? "Unlimited"
                  : convertToGB(
                      pastConsumption?.currentDeal?.packages[0]?.includedData
                    )
              } GB` : "-",
            },
            {
              label: "Voice",
              value: pastConsumption?.currentDeal?.packages[0]?.includedMinutes ? `${
                pastConsumption?.currentDeal?.packages[0]?.includedMinutes ==
                "-1"
                  ? "Unlimited"
                  : pastConsumption?.currentDeal?.packages[0]?.includedMinutes
              } minutes` : "-",
            },
            {
              label: "SMS",
              value: pastConsumption?.currentDeal?.packages[0]?.includedSms ? `${
                pastConsumption?.currentDeal?.packages[0]?.includedSms == "-1"
                  ? "Unlimited"
                  : pastConsumption?.currentDeal?.packages[0]?.includedSms
              } Sms` : "-",
            },
            {
              label: "Airtime",
              value: "-",
            },
          ],
        },
      ],
    },
  ];

  const generateClass = (eventKey) => {
    return eventKey === activeAccordion
      ? `${styles["accordion__toggle"]} ${styles["accordion__toggle--active"]}`
      : styles["accordion__toggle"];
  };
  const accordElem = useRef(null);

  const CustomToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      if (eventKey === activeAccordion) {
        setActiveAccordion("");
      } else {
        setActiveAccordion(eventKey);
        accordElem?.current?.scrollIntoView();
      }
    });

    return (
      <CustomContainer
        className={generateClass(eventKey)}
        onClick={decoratedOnClick}
      >
        {children}
      </CustomContainer>
    );
  };
  //  && pastUsage?.usage
  return (
    <>
      <button
        className={styles["go-back-btn"]}
        onClick={() => props.setActiveTab("Recommended deals")}
      >
        <span>
          <img className={styles["back-img"]} src={backImg} height={12} />
        </span>
        <span>{"Go back to deals"}</span>
      </button>

      {pastConsumption ? (
        <>
          <Row className="d-none d-md-block d-lg-block">
            <Col xs={12}>
              <Tab.Content className={`${styles["tab-content"]}`}>
                {tabNames.map((tab, index) => (
                  <>
                    <LabelText className={styles["accordion-title"]}>
                      {tab.title}
                    </LabelText>
                    <CustomContainer>
                      <p>{tab.description}</p>
                      <Row className={styles["pastusage-content-boxes"]}>
                        {tab.data &&
                          tab.data.length > 0 &&
                          tab?.data.map((d) => (
                            <Col
                              md={6}
                              lg={4}
                              className={`${styles["box-container"]} pr-0  ${
                                d.hidden && styles["hide-block"]
                              }`}
                            >
                              <Col key={d.name} className={styles.boxes}>
                                <LabelText>{d.name}</LabelText>
                                <LabelText
                                  className={`${styles["data-usage"]} ${
                                    d.error && styles["error-warning"]
                                  }`}
                                >
                                  {d.error && (
                                    <CustomContainer
                                      className={styles["error-icon"]}
                                    >
                                      <img src={errorImg} width={30} />
                                    </CustomContainer>
                                  )}
                                  {d.usage}
                                </LabelText>
                                <p
                                  className={`${styles["data-des"]} ${
                                    d.error && styles["error-warning--des"]
                                  }`}
                                  dangerouslySetInnerHTML={{ __html: d.des }}
                                >
                                  {}
                                </p>
                              </Col>
                            </Col>
                          ))}
                      </Row>
                      {tab.overSpend &&
                      pastConsumption?.consumption?.spendMinusSubsc > 0 ? (
                        <CustomContainer className={styles["OverSpend-div"]}>
                          <CustomContainer
                            className={styles["OverSpend-div__title"]}
                            dangerouslySetInnerHTML={{
                              __html: props.pastUsageParagraph?.heading,
                            }}
                          >
                            {/* {props.pastUsageParagraph?.heading} */}
                          </CustomContainer>
                          <CustomContainer
                            className={styles["OverSpend-div__description"]}
                            dangerouslySetInnerHTML={{
                              __html: overSpendDescription.replace(
                                "[average_monthly_amount]&nbsp;",
                                `<strong>${pastConsumption?.consumption?.spendMinusSubsc?.toFixed(
                                  2
                                )} </strong>`
                              ),
                            }}
                          ></CustomContainer>
                        </CustomContainer>
                      ) : (
                        ""
                      )}
                      {tab.contract_data &&
                        tab.contract_data.length > 0 &&
                        tab.contract_data.map((contract) => (
                          <>
                            <LabelText className={styles["contract-type"]}>
                              {contract.type}
                            </LabelText>
                            <CustomContainer
                              className={styles["details-deal-sub-section"]}
                            >
                              {contract.data.map((tbl_dt) => (
                                <Row
                                  className={`mx-0 ${styles["details-section-row"]}`}
                                >
                                  <Col
                                    md={6}
                                    // xs={activeTab == "DESC" ? 6 : 12}
                                    xs={12}
                                  >
                                    <LabelText
                                      className={`${styles["details-label"]}`}
                                    >
                                      {tbl_dt.label}:
                                    </LabelText>
                                  </Col>
                                  <Col
                                    md={6}
                                    // xs={activeTab == "DESC" ? 6 : 12}
                                    xs={12}
                                  >
                                    <LabelText
                                      className={styles["details-value"]}
                                    >
                                      {tbl_dt.value}
                                    </LabelText>
                                  </Col>
                                </Row>
                              ))}
                            </CustomContainer>
                          </>
                        ))}
                    </CustomContainer>
                  </>
                ))}
              </Tab.Content>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="d-block d-md-none d-lg-none">
              <Accordion ref={accordElem}>
                {tabNames.map((tab, index) => (
                  <CustomContainer className={styles["accordion"]} key={index}>
                    <Row>
                      <Col xs={12}>
                        <CustomToggle
                          eventKey={tab.key}
                          className={styles["accordion-title"]}
                        >
                          {tab.title}
                        </CustomToggle>
                      </Col>
                    </Row>
                    <Accordion.Collapse eventKey={tab.key}>
                      <CustomContainer
                        className={styles["accordion__collapse border-none"]}
                      >
                        {tab.description}
                        {tab.data &&
                          tab.data.length > 0 &&
                          tab?.data.map((d) => (
                            <CustomContainer
                              key={d.name}
                              className={`${styles.boxes} ${
                                d.hidden && styles["hide-block"]
                              }`}
                            >
                              <LabelText>{d.name}</LabelText>
                              <LabelText
                                className={`${styles["data-usage"]} ${
                                  d.error && styles["error-warning"]
                                }`}
                              >
                                {d.error && (
                                  <CustomContainer
                                    className={styles["error-icon"]}
                                  >
                                    <img src={errorImg} width={24} />
                                  </CustomContainer>
                                )}
                                {d.usage}
                              </LabelText>
                              <p
                                className={`${styles["data-des"]} ${
                                  d.error && styles["error-warning--des"]
                                }`}
                                dangerouslySetInnerHTML={{ __html: d.des }}
                              ></p>
                            </CustomContainer>
                          ))}
                        {tab.overSpend &&
                        pastConsumption?.consumption?.spendMinusSubsc > 0 ? (
                          <CustomContainer className={styles["OverSpend-div"]}>
                            <CustomContainer
                              className={styles["OverSpend-div__title"]}
                              dangerouslySetInnerHTML={{
                                __html: props.pastUsageParagraph?.heading,
                              }}
                            >
                              {/* {props.pastUsageParagraph?.heading} */}
                            </CustomContainer>
                            <CustomContainer
                              className={styles["OverSpend-div__description"]}
                              dangerouslySetInnerHTML={{
                                __html: overSpendDescription.replace(
                                  "[average_monthly_amount]&nbsp;",
                                  `<strong>${pastConsumption?.consumption?.spendMinusSubsc?.toFixed(
                                    2
                                  )} </strong>`
                                ),
                              }}
                            ></CustomContainer>
                          </CustomContainer>
                        ) : (
                          ""
                        )}
                        {tab.contract_data &&
                          tab.contract_data.length > 0 &&
                          tab.contract_data.map((contract) => (
                            <>
                              <LabelText className={styles["contract-type"]}>
                                {contract.type}
                              </LabelText>
                              <CustomContainer
                                className={styles["details-deal-sub-section"]}
                              >
                                {contract.data.map((tbl_dt) => (
                                  <Row
                                    className={`mx-0 ${styles["details-section-row"]}`}
                                  >
                                    <Col
                                      md={4}
                                      // xs={activeTab == "DESC" ? 6 : 12}
                                      xs={6}
                                    >
                                      <LabelText
                                        className={`${styles["details-label"]}`}
                                      >
                                        {tbl_dt.label}:
                                      </LabelText>
                                    </Col>
                                    <Col
                                      md={8}
                                      // xs={activeTab == "DESC" ? 6 : 12}
                                      xs={6}
                                    >
                                      <LabelText
                                        className={styles["details-value"]}
                                      >
                                        {tbl_dt.value}
                                      </LabelText>
                                    </Col>
                                  </Row>
                                ))}
                              </CustomContainer>
                            </>
                          ))}
                      </CustomContainer>
                    </Accordion.Collapse>
                  </CustomContainer>
                ))}
              </Accordion>
            </Col>
          </Row>
          <span className={styles["section-divider"]}></span>

          <Row>
            <Col className={`text-center ${styles["cta-spacing"]}`}>
              <CTAButton
                className={styles["cta-btn"]}
                variant={btnConfig.buttonStyle}
                handleClick={goToTop}
              >
                {btnConfig.buttonLabel}
              </CTAButton>
            </Col>
          </Row>
        </>
      ) : (
        <>
          {isApiError && (
            <CustomContainer className={styles["error-message"]}>
              <img src={imgUrl} width={15} height={15} className={styles["error-image"]} />
              <span>{
                "We seem to be having some issues retrieving your past usage  data right now. Please try again later."
              }</span>
            </CustomContainer>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  // pastData: state.upgrade.pastUsageData,
  pastConsumptionData: state.upgrade.pastConsumptionData,
  responseToken: state.upgrade.responseToken,
  userLoggedIn: state.navDetails.isUserLoggedIn,
});

export default connect(mapStateToProps, { getPastUsage })(PastUsage);
